<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

const emit = defineEmits(['filter']);

const { t } = useI18n();

const stats = useMapGetter('campaigns/getCampaignStats');
const isFetching = useMapGetter('campaigns/isStatsFetching');

const cards = computed(() => {
  const s = stats.value || {};
  return [
    {
      key: null,
      label: t('CAMPAIGN.DASHBOARD.METRICS.TOTAL'),
      value: s.total || 0,
      color: 'text-n-slate-12',
      borderColor: 'border-t-n-slate-8',
    },
    {
      key: 'active',
      label: t('CAMPAIGN.DASHBOARD.METRICS.ACTIVE'),
      value: s.active || 0,
      color: 'text-n-teal-11',
      borderColor: 'border-t-n-teal-9',
    },
    {
      key: 'scheduled',
      label: t('CAMPAIGN.DASHBOARD.METRICS.SCHEDULED'),
      value: s.scheduled || 0,
      color: 'text-n-amber-11',
      borderColor: 'border-t-n-amber-9',
    },
    {
      key: 'success',
      label: t('CAMPAIGN.DASHBOARD.METRICS.SUCCESS'),
      value: s.success || 0,
      color: 'text-n-teal-11',
      borderColor: 'border-t-n-teal-9',
    },
    {
      key: 'error',
      label: t('CAMPAIGN.DASHBOARD.METRICS.ERRORS'),
      value: (s.partial || 0) + (s.failed || 0),
      color: 'text-n-ruby-11',
      borderColor: 'border-t-n-ruby-9',
    },
  ];
});
</script>

<template>
  <!-- eslint-disable vue/no-static-inline-styles -->
  <div
    class="grid gap-3 mb-4"
    style="grid-template-columns: repeat(auto-fill, minmax(148px, 1fr))"
  >
    <!-- eslint-enable vue/no-static-inline-styles -->
    <button
      v-for="card in cards"
      :key="card.label"
      class="bg-n-solid-2 border border-n-weak border-t-2 rounded-[10px] p-4 text-left transition-colors hover:border-n-strong focus:outline-none focus:ring-2 focus:ring-n-blue-7"
      :class="card.borderColor"
      @click="emit('filter', card.key)"
    >
      <div
        class="text-[11px] font-medium uppercase tracking-wider text-n-slate-9 mb-1.5"
      >
        {{ card.label }}
      </div>
      <template v-if="isFetching">
        <div class="animate-pulse">
          <div class="h-7 w-12 bg-n-solid-3 rounded" />
        </div>
      </template>
      <template v-else>
        <div class="text-2xl font-bold" :class="card.color">
          {{ card.value }}
        </div>
      </template>
    </button>
  </div>
</template>
